module.exports = __webpack_public_path__ + "static/paula-1-941581027de1fec12e00e592ea31797c.jpeg";